module.exports = __webpack_public_path__ + "img/desc1.42673477.png";